import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from "./locale.en_US"
import zh from "./locale.zh_CN"

Vue.use(VueI18n)

const messages = {
  en,
  zh,
}


const i18n = new VueI18n({
  locale: localStorage.getItem('locale') || 'en', // 设置地区
  messages,
})

export default i18n